/**
 * Colors from the Presentation Builder V2 design mock (docs/design/presentation-builder-v2,
 * epic #22197) that aren't part of the app-wide theme palette. Shared across the inspector
 * chrome and OptionsPopup controls so the redesign stays visually consistent as more of it
 * lands.
 */
export const BUILDER_V2_INK = '#1D2433'
export const BUILDER_V2_MUTED_TEXT = '#5B6675'
export const BUILDER_V2_HOVER_BACKGROUND = '#EEF1F5'
export const BUILDER_V2_SELECTED_BACKGROUND = '#DCE6F5'
export const BUILDER_V2_BORDER = '#DDE0E6'
/** Lighter secondary-label grey — panel-header subtitles, empty-state icon, etc. Distinct from the darker BUILDER_V2_MUTED_TEXT used for body copy. */
export const BUILDER_V2_MUTED_LABEL = '#9AA4B2'
/** Lightest muted-icon grey — sub-panel close buttons (inspector, variants flyout) and row chevrons. */
export const BUILDER_V2_ICON_MUTED = '#B4BCC8'
/** Selected/active row background+text in a category or catalog list (Add panel's Sections accordion, …). Distinct from BUILDER_V2_SELECTED_BACKGROUND, which is a different control's selected state. */
export const BUILDER_V2_ROW_SELECTED_BACKGROUND = '#EAF1FE'
export const BUILDER_V2_ROW_SELECTED_TEXT = '#0F4FB0'
/** Small helper/description copy under a panel title (e.g. the Add panel's "Page names will show..." blurb). Distinct from BUILDER_V2_MUTED_LABEL and BUILDER_V2_MUTED_TEXT — the mock uses a third, in-between grey here. */
export const BUILDER_V2_HELPER_TEXT = '#8A94A2'
/** Hover text/icon color for the chrome's transparent icon buttons (top bar undo/redo, panel close buttons). */
export const BUILDER_V2_CHROME_HOVER_TEXT = '#46505F'
/** The mock's chrome accent blue (`const accent` in `Presentation Builder V2.dc.html`) — canvas drop-zone hover state (#22208), not the presentation's own theme accent color. */
export const BUILDER_V2_ACCENT = '#1668E3'
/** Hover background for solid BUILDER_V2_ACCENT buttons (the "Feeling stuck?" pill, #25096). */
export const BUILDER_V2_ACCENT_HOVER = '#0F57C4'
/** Default (non-hovered) canvas drop-zone rail line color. */
export const BUILDER_V2_ZONE_LINE = '#D6DAE1'
/** Panel/chrome hairline border — top bar, Add panel block tiles, canvas page tab strip. */
export const BUILDER_V2_PANEL_BORDER = '#EDEEF1'
/** Canvas page tab strip's own background, behind the tabs themselves. */
export const BUILDER_V2_TAB_BAR_BACKGROUND = '#F6F7F9'
/** Inactive canvas page tab background. */
export const BUILDER_V2_TAB_INACTIVE_BACKGROUND = '#E8EBF0'
/** Inactive canvas page tab label color. */
export const BUILDER_V2_TAB_INACTIVE_TEXT = '#6B7684'
/** Content tree's nested-row drag handle glyph (section/block rows in the Pages panel). */
export const BUILDER_V2_DRAG_HANDLE = '#C2C8D2'
/** Amber warning border — the Settings panel's estimate-missing notice + top bar chip (#22212). */
export const BUILDER_V2_WARNING_BORDER = '#F0C9A8'
/** Amber warning background, pairs with BUILDER_V2_WARNING_BORDER. */
export const BUILDER_V2_WARNING_BACKGROUND = '#FDF3E9'
/** Amber warning background on hover (top bar chip). */
export const BUILDER_V2_WARNING_HOVER_BACKGROUND = '#FBEBDC'
/** Amber warning icon color. */
export const BUILDER_V2_WARNING_ICON = '#9A5B18'
/** Amber warning body-text color — slightly darker than BUILDER_V2_WARNING_ICON for contrast on the light amber background. */
export const BUILDER_V2_WARNING_TEXT = '#7A4712'
